import styled from 'styled-components';
import { PortalButton } from '../BuildingBlocks/PortalButton/PortalButton';
import * as mixins from './mixins';

export const BigPortalButton = styled(PortalButton)`
  font-size: 1em;
  width: 220px;
  max-width: 100%;
  padding-top: ${mixins.pxToRem(10)};
  padding-bottom: ${mixins.pxToRem(10)};
`;
